import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Permission} from '../model/permission.model';
import {ApiService} from './api.service';

@Injectable({providedIn: 'root'})
export class PermissionService {

  private permissions: Permission[] = [];

  constructor(private apiService: ApiService) {
    new Observable<Permission[]>(subscriber => {
      this.apiService.send({
        command: 'permission',
        request: {}
      }, (response) => {
        let permissions: Permission[] = [];

        response = response.response;
        if (!response.error && Array.isArray(response)) {
          for (const type of response) {
            permissions.push({
              id: type.id,
              name: type.name,
              system: type.system
            })
          }
          subscriber.next(permissions);
        }
      });
    }).subscribe((types) => {
      this.permissions = types;
    });
  }

  getPermissions(system?: boolean) {
    return this.permissions.filter(n => system === undefined || n.system === system);
  }

  getName(permissionId) {
    for (const permission of this.getPermissions()) {
      if (permission.id === permissionId) {
        return permission.name;
      }
    }
    return permissionId;
  }
}
